﻿import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "@/features/axiosHelper";
import { ReferenceType } from "@/utils/utils";
import _ from "lodash";
//import { create } from "@mui/material/styles/createTransitions";
import { createAlert } from "@/features/homepage/alertSliceList";
import { CrossReferenceTypes } from "@/utils/utils";
const defaultState = {
  selectedReferenceType: -1,
  referenceSchema: {},
  referenceTypes: [],
  connectionPair: {
    connectionPairId: -1,
    connectionPairName: "None",
  },
  connectionPairsList: [
    {
      connectionPairId: -1,
      connectionPairName: "None",
    },
  ],
  rows: [],
  selectedRows: [],
  status: "initial",
  error: null,
  mapOnFlyInfo: {
    crossReferenceInfo: "",
    crossReferenceWorkflowRecordId: "",
    loading: true,
  },
  isMapOnFlyOpen: false,
  catalogs: {},
  catalogFilter: {},
  isAddCrossRefOpen: false,
  toggle: false, // For Add xref screen only
  missingCrossReferenceCounts: {
    //for map on fly screen only
    Customer: 0,
    ShipTo: 0,
    Item: 0,
    UOM: 0,
    Warehouse: 0,
    Carrier: 0,
    MiscCharges: 0,
  },
  selectedXref: -1,
  sourceGridLoaded: false,
  targetGridLoaded: false,
  mappedGridLoaded: false,
  hasPendingLocalChanges: false,
};

const crossReferenceSlice = createSlice({
  name: "crossReference",
  initialState: defaultState,
  reducers: {
    setReferenceType: (state, action) => {
      const { refType } = action.payload;
      state.selectedReferenceType = refType;
    },
    setReferenceTypeEnum: (state, action) => {
      const { refTypes } = action.payload;
      state.referenceTypes = refTypes;
    },
    setRowsData: (state, action) => {
      const { rows } = action.payload;
      state.rows = rows;
    },
    setConnectionPair: (state, action) => {
      const { pair } = action.payload;
      state.connectionPair = pair;
    },
    setSelectedRow: (state, action) => {
      const { rows } = action.payload;
      state.selectedRows = rows;
    },
    setReferenceSchema: (state, action) => {
      const { schema } = action.payload;
      state.referenceSchema = schema;
    },
    setConnectionPairsList: (state, action) => {
      const { pairs } = action.payload;
      state.connectionPairsList = pairs;
    },
    setMapOnFlyInfo: (state, action) => {
      const { crossReferenceInfo, crossReferenceWorkflowRecordId } =
        action.payload;
      state.mapOnFlyInfo.crossReferenceInfo = crossReferenceInfo;
      state.mapOnFlyInfo.crossReferenceWorkflowRecordId =
        crossReferenceWorkflowRecordId;
      state.mapOnFlyInfo.loading = false;
    },
    clearMapOnFlyInfo: (state, action) => {
      state.mapOnFlyInfo.loading = true;
    },
    setIsMapOnFlyOpen: (state, action) => {
      const { value } = action.payload;
      state.isMapOnFlyOpen = value;
    },
    setIsAddCrossRefOpen: (state, action) => {
      const { value } = action.payload;
      state.isAddCrossRefOpen = value;
    },
    addPendingMappedSourceCatalogs: (state, action) => {
      const { sourceId, targetId, xrefJSON, insertType } = action.payload;

      const unmappedSource = state.catalogs.sourceCatalogs.find(
        (x) => x.CatalogId === sourceId,
      );
      const unmappedTarget = state.catalogs.targetCatalogs.find(
        (x) => x.CatalogId === targetId,
      );

      const pendingMappedCatalog = {
        ...unmappedSource,
        InsertType: insertType,
        MappedCatalogId: unmappedTarget.CatalogId,
        MappedCatalogReference: unmappedTarget.CatalogReference,
        MappedJSONProperties: unmappedTarget.JSONProperties,
        CrossReferenceJSONProperties: JSON.stringify(xrefJSON), //supplemental info only used once saved in backend
        MappedArtifactData: unmappedTarget.ArtifactData,
      };

      const newMappedSourceCatalogs = [
        ...state.catalogs.mappedSourceCatalogs,
        pendingMappedCatalog,
      ];

      //update status for Target Catalogs
      const newTarget = {
        ...unmappedTarget,
        CrossReferenceMappingId: null,
        MappedCatalogId: unmappedTarget.CatalogId,
        MappedCatalogReference: unmappedTarget.CatalogReference,
        MappedJSONProperties: unmappedTarget.JSONProperties,
      };
      const filteredTargetList = state.catalogs.targetCatalogs.filter(
        (x) => x.CatalogId !== targetId,
      );
      const newTargetList = [...filteredTargetList, newTarget];

      state.catalogs.sourceCatalogs = state.catalogs.sourceCatalogs.filter(
        (x) => x.CatalogId !== sourceId,
      );
      state.catalogs.mappedSourceCatalogs = newMappedSourceCatalogs;
      state.catalogs.targetCatalogs = newTargetList;
      //mark pending
      state.hasPendingLocalChanges = true;
    },
    removeMappedSourceCatalog: (state, action) => {
      const { sourceId, targetId } = action.payload;

      //get entry that we will remove the map from
      const deletedMapping = state.catalogs.mappedSourceCatalogs.find(
        (x) => x.CatalogId === sourceId && x.MappedCatalogId === targetId,
      );

      //SHEP-729 maintain a list in state of catalogs that have been unmapped in the UI but not yet saved to the DB

      const updatedPendingUnmappingCatalogs = [
        deletedMapping.CatalogId,
        ...(state.catalogs.pendingUnmappingCatalogIds ?? []),
      ];

      //get list of mappings without the to-be removed one
      const newMappedSourceCatalogs =
        state.catalogs.mappedSourceCatalogs.filter(
          (x) => x.CatalogId !== sourceId || x.MappedCatalogId !== targetId,
        );

      //update state of associated source catalog
      const newSource = {
        ...deletedMapping,
        CrossReferenceMappingId: null,
        MappedCatalogId: null,
        MappedCatalogReference: null,
        MappedArtifactData: null,
      };

      const filteredSourceList = state.catalogs.sourceCatalogs.filter(
        (x) => x.CatalogId !== sourceId,
      );

      const newSourceList = [...filteredSourceList, newSource];

      // mark target as unmapped again
      const existingTarget = state.catalogs.targetCatalogs.find(
        (x) => x.CatalogId === targetId,
      );
      const newTarget = existingTarget
        ? {
          ...existingTarget,
          CrossReferenceMappingId: null,
          MappedCatalogId: null,
          MappedCatalogReference: null,
          MappedArtifactData: null,
        }
        : null;
      const filteredTargetList = state.catalogs.targetCatalogs.filter(
        (x) => x.CatalogId !== targetId,
      );
      const newTargetList = newTarget
        ? [...filteredTargetList, newTarget]
        : filteredTargetList;

      state.catalogs = {
        mappedSourceCatalogs: newMappedSourceCatalogs,
        sourceCatalogs: newSourceList,
        targetCatalogs: newTargetList,
        pendingUnmappingCatalogIds: updatedPendingUnmappingCatalogs,
      };
      // mark pending
      state.hasPendingLocalChanges = true;
    },
    setCatalogFilter: (state, action) => {
      const { filter } = action.payload;
      state.catalogFilter = { ...state.catalogFilter, ...filter };
    },
    resetCatalogFilter: (state, action) => {
      state.catalogFilter = {};
    },
    setToggle: (state, action) => {
      const { value } = action.payload;
      state.toggle = value;
    },
    setMissingCrossRefCounts: (state, action) => {
      const { counts } = action.payload;
      state.missingCrossReferenceCounts = counts;
    },
    setSelectedXrefType: (state, action) => {
      const { selectedXref } = action.payload;
      state.selectedXref = selectedXref;
      // reset pending when switching tabs so we go back to server state
      state.hasPendingLocalChanges = false;
      state.catalogs = {
        mappedSourceCatalogs: [],
        sourceCatalogs: [],
        targetCatalogs: [],
      };
    },
    clearPendingLocalChanges: (state) => {
      state.hasPendingLocalChanges = false; //explicit cancel/reset
    },
    setMappedGridFlag: (state, action) => {
      const { mappedGridLoaded } = action.payload;
      state.mappedGridLoaded = mappedGridLoaded;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCrossReferenceDetails.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCrossReferenceDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCrossReferenceDetails.fulfilled, (state, action) => {
        state.status = "loaded";
        state.rows = action.payload;
      })
      .addCase(fetchCrossReferenceSchema.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCrossReferenceSchema.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCrossReferenceSchema.fulfilled, (state, action) => {
        state.status = "loaded";
        state.referenceSchema = action.payload.data;
      })
      .addCase(fetchReferenceTypeEnum.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchReferenceTypeEnum.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchReferenceTypeEnum.fulfilled, (state, action) => {
        state.status = "loaded";
        state.referenceTypes = action.payload.data;
      })
      .addCase(deleteCrossReferenceMapping.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(deleteCrossReferenceMapping.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(deleteCrossReferenceMapping.fulfilled, (state, action) => {
        state.status = "loaded";
        //state.recordsData = action.payload;
      })
      .addCase(addCrossReferenceMapping.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(addCrossReferenceMapping.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addCrossReferenceMapping.fulfilled, (state, action) => {
        state.status = "loaded";
        //state.recordsData = action.payload;
      })
      .addCase(updateCrossReferenceMapping.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(updateCrossReferenceMapping.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateCrossReferenceMapping.fulfilled, (state, action) => {
        state.status = "loaded";
        //state.recordsData = action.payload;
      })
      .addCase(fetchCatalogCodes.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(fetchCatalogCodes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchCatalogCodes.fulfilled, (state, action) => {
        state.status = "loaded";
        //state.recordsData = action.payload;
      })

      //source grid
      .addCase(fetchSourceConnectionCatalogs.pending, (state, action) => {
        state.sourceGridLoaded = false;
        state.status = "loading";
      })
      .addCase(fetchSourceConnectionCatalogs.rejected, (state, action) => {
        state.sourceGridLoaded = true;
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchSourceConnectionCatalogs.fulfilled, (state, action) => {
        const mappedIds = new Set(
          (state.catalogs.mappedSourceCatalogs || []).map((m) => m.CatalogId),
        );
        //ensure no mapped source catalog leaks into unmapped list
        state.catalogs.sourceCatalogs = (
          action.payload.sourceCatalogs || []
        ).filter((x) => {
          // Bypass invalid records.
          // This ensures the logic below does not filter out invalid [DEFAULT] cases
          // when a catalogType has a default cross-reference mapping.

          if (x.DefaultMappingType === DefaultMappingTypes.Invalid) {
            return true;
          }

          // Apply standard filtering for everything else
          return !mappedIds.has(x.CatalogId);
        });

        state.sourceGridLoaded = true;
      })
      //target grid
      .addCase(fetchTargetConnectionCatalogs.pending, (state, action) => {
        state.targetGridLoaded = false;
        state.status = "loading";
      })
      .addCase(fetchTargetConnectionCatalogs.rejected, (state, action) => {
        state.targetGridLoaded = true;
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchTargetConnectionCatalogs.fulfilled, (state, action) => {
        state.catalogs.targetCatalogs = action.payload.targetCatalogs;
        state.targetGridLoaded = true;
      })
      //mapped grid
      .addCase(fetchMappedCatalogs.pending, (state, action) => {
        state.mappedGridLoaded = false;
        state.status = "loading";
      })
      .addCase(fetchMappedCatalogs.rejected, (state, action) => {
        state.mappedGridLoaded = true;
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchMappedCatalogs.fulfilled, (state, action) => {
        // prevent overwriting mapped list while pending after server returns mapped catalogs
        if (!state.hasPendingLocalChanges) {
          state.catalogs.mappedSourceCatalogs =
            action.payload.mappedSourceCatalogs;
          //SHEP-729, reset the pending umapping catalogs whenever the mapped catalogs are refetched, this should return the 'true' state
          state.catalogs.pendingUnmappingCatalogIds = [];
        }
        state.mappedGridLoaded = true;
      })
      // reset pending flag after successful save
      .addCase(saveNewMappings.fulfilled, (state) => {
        state.hasPendingLocalChanges = false;
      })
      .addCase(saveNewMappings.rejected, () => { })
      .addCase(saveNewCrossReferenceMappings.fulfilled, (state) => {
        // now unique action type
        state.hasPendingLocalChanges = false;
      })
      .addCase(saveNewCrossReferenceMappings.rejected, () => { });
  },
});

export const fetchCrossReferenceDetails = createAsyncThunk(
  "crossReference/fetchCrossReferenceDetails",
  async (_, { getState }) => {
    const state = getState();
    const response = await axios
      .get("/crossreference", {
        params: {
          connectionPairId:
            state.tempInfo.crossReference.connectionPair.connectionPairId,
          crossReferenceType:
            state.tempInfo.crossReference.selectedReferenceType,
        },
      })
      .then((response) => {
        const r = response.data.map((row) => {
          if (row.jsonProperties !== "") {
            const property = JSON.parse(row.jsonProperties);
            const objectMap = (obj, connection) =>
              Object.fromEntries(
                Object.entries(obj).map(([k, v]) => [k + connection, v]),
              );
            return {
              id: row.crossReferenceMappingId,
              ...objectMap(property[0], "1"),
              ...objectMap(property[1], "2"),
              JSONProperties: row.jsonProperties,
              crossReferenceType: row.crossReferenceType,
              connectionPairId: row.connectionPairId,
            };
          } else {
            return {
              id: row.crossReferenceMappingId,
            };
          }
        });
        return r;
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
    return response;
  },
);
export const fetchCrossReferenceSchema = createAsyncThunk(
  "crossReference/fetchCrossReferenceSchema",
  async (_, { getState }) => {
    const state = getState();
    const response = await axios.get("/crossreference/schema", {
      params: {
        crossRefType: state.tempInfo.crossReference.selectedReferenceType,
      },
    });
    return response;
  },
);
export const fetchReferenceTypeEnum = createAsyncThunk(
  "crossReference/fetchReferenceTypeEnum",
  async () => {
    const response = await axios.get("/crossreference/cross-reference-types");
    return response;
  },
);
export const deleteCrossReferenceMapping = createAsyncThunk(
  "crossReference/deleteCrossReferenceMapping",
  async ({
    selectedMappings,
    crossReferenceType,
    connectionPairId,
    cascadingDelete
  }) => {
    const response = await axios.delete("/crossreference", {
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        crossReferenceType,
        connectionPairId,
        cascadingDelete: cascadingDelete,
      },
      data: selectedMappings,
    });
    return response;
  },
);

export const addCrossReferenceMapping = createAsyncThunk(
  "crossReference/addCrossReferenceMapping",
  async ({ newReference }) => {
    const response = await axios.post("/crossreference", null, {
      params: {
        jsonNewReference: newReference,
      },
    });
    return response;
  },
);
export const updateCrossReferenceMapping = createAsyncThunk(
  "crossReference/updateCrossReferenceMapping",
  async ({ jsonToSend }) => {
    const response = await axios.put("/crossreference", null, {
      params: {
        jsonUpdatedCrossReference: jsonToSend,
      },
    });
    return response;
  },
);

export const fetchCatalogCodes = createAsyncThunk(
  "crossReference/fetchCatalogCodes",
  async (connectionId, { getState }) => {
    const state = getState();
    const response = await axios.get("/crossreference/catalog-codes", {
      params: {
        connectionId: connectionId,
        crossReferenceType: state.tempInfo.crossReference.selectedReferenceType,
      },
    });
    return response;
  },
);
export const fetchConnectionMandatoryQualifiers = createAsyncThunk(
  "crossReference/fetchMandatoryQualifiers",
  async ({ connectionId }) => {
    const response = await axios.get("/crossreference/mandatory-qualifiers", {
      params: {
        connectionId: connectionId,
      },
    });
    return response;
  },
);

export const fetchDefaultMappingExists = createAsyncThunk(
  "crossReference/fetchDefaultMappingExists",
  async (_, { getState }) => {
    const state = getState();
    const response = await axios.get("/crossreference/default-mapping", {
      params: {
        connectionPairId:
          state.tempInfo.crossReference.connectionPair?.connectionPairId,
        catalogType: state.tempInfo.crossReference.selectedReferenceType,
      },
    });
    return response;
  },
);

export const fetchSourceConnectionCatalogs = createAsyncThunk(
  "crossReference/fetchSourceConnectionCatalogs",
  async (
    {
      connectionPairId,
      crossReferenceType,
      sourceConnectionId,
      targetConnectionId,
      searchFilter,
    },
    { getState },
  ) => {
    const state = getState();
    const crossReferenceTypeNum =
      state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
        .CrossReferenceTypes[crossReferenceType];
    let sourceResponse = "";

    const mappedSourceCatalogs =
      state.tempInfo.crossReference.catalogs.mappedSourceCatalogs || [];

    const pendingUnmappingCatalogIds =
      state.tempInfo.crossReference.catalogs.pendingUnmappingCatalogIds ?? [];

    //SHEP-484
    //Map on fly requires additional info for filtering
    if (!state.tempInfo.crossReference.isAddCrossRefOpen) {
      const operationId =
        state.sessionInfo.workflowManagerSession.selectedWorkflow;
      const sourceArtifactId =
        state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
          .SourceArtifactDictionaryDataId;
      sourceResponse = await axios.post(
        "/crossreference/map-on-fly/catalogs-source",
        {
          sourceArtifactId: sourceArtifactId,
          operationId: operationId,
          crossReferenceType: crossReferenceTypeNum,
          connectionPairId: connectionPairId,
          sourceConnectionId: sourceConnectionId,
          targetConnectionId: targetConnectionId,
          searchFilter,
          pendingUnmappingCatalogIds,
          clearCache: true,
        },
      );
    } else {
      sourceResponse = await axios.get("/crossreference/catalogs-source", {
        params: {
          crossReferenceType: crossReferenceTypeNum,
          connectionPairId,
          sourceConnectionId,
          targetConnectionId,
          searchFilter,
          pendingUnmappingCatalogIds,
          clearCache: true,
        },
      });
    }

    let base = sourceResponse.data.SourceCatalogs || [];

    // merge in locally available (unmapped but not saved) items that server doesn't return because it still thinks they're mapped
    const localSource =
      state.tempInfo.crossReference.catalogs.sourceCatalogs || [];
    const serverIds = new Set(base.map((x) => x.CatalogId));
    const filterText = (searchFilter || "").toLowerCase();

    let merged = base;

    const selectedXref = state.tempInfo.crossReference.selectedXref;
    const allowLocalOverlay =
      state.tempInfo.crossReference.hasPendingLocalChanges &&
      selectedXref === crossReferenceType;

    if (allowLocalOverlay) {
      // merge in locally available (unmapped but not saved) items that server doesn't return
      const additionalLocal = localSource.filter((x) => {
        if (serverIds.has(x.CatalogId)) return false;
        if (!filterText) return true;
        return (x.CatalogReference || "").toLowerCase().includes(filterText);
      });

      merged = [...base, ...additionalLocal];
    }

    // Exclude any sources that are currently pending mapped (from local truth)
    if (
      Array.isArray(mappedSourceCatalogs) &&
      mappedSourceCatalogs.length > 0
    ) {
      const mappedSourceIds = new Set(
        mappedSourceCatalogs.map((m) => m.CatalogId),
      );

      merged = merged.filter((src) => {
        // Bypass invalid records.
        // This ensures the logic below does not filter out invalid [DEFAULT] cases
        // when a catalogType has a default cross-reference mapping.
        if (src.DefaultMappingType === DefaultMappingTypes.Invalid) {
          return true;
        }

        // For all other records, apply the normal exclusion logic
        return !mappedSourceIds.has(src.CatalogId);
      });
    }

    return {
      sourceCatalogs: merged,
    };
  },
);

export const fetchTargetConnectionCatalogs = createAsyncThunk(
  "crossReference/fetchTargetConnectionCatalogs",
  async (
    {
      connectionPairId,
      crossReferenceType,
      sourceConnectionId,
      targetConnectionId,
      sourceCatalogIdList,
      parentIsDefault,
      searchFilter,
    },
    { getState },
  ) => {
    const state = getState();
    const crossReferenceTypeNum =
      state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
        .CrossReferenceTypes[crossReferenceType];

    const sourceCatalogIds = sourceCatalogIdList?.join(",") ?? "";
    const targetResponse = await axios.get("/crossreference/catalogs-target", {
      params: {
        crossReferenceType: crossReferenceTypeNum,
        connectionPairId,
        sourceConnectionId,
        targetConnectionId,
        sourceCatalogIds,
        parentIsDefault,
        searchFilter,
        clearCache: true,
      },
    });

    // Preserve server-provided mapping flags so already-mapped targets remain visually distinct
    const baseTargets = targetResponse.data.TargetCatalogs || [];

    // Overlay local pending mapping state for consistent highlighting (without losing server flags)
    const mappedSourceCatalogs =
      state.tempInfo.crossReference.catalogs.mappedSourceCatalogs || [];

    // Build a set of target IDs currently chosen locally
    const mappedTargetIdSet = new Set(
      mappedSourceCatalogs
        .filter((m) => m.MappedCatalogId != null)
        .map((m) => m.MappedCatalogId),
    );

    const selectedXref = state.tempInfo.crossReference.selectedXref;
    const allowLocalOverlay =
      state.tempInfo.crossReference.hasPendingLocalChanges &&
      selectedXref === crossReferenceType;

    const patchedTargets = allowLocalOverlay
      ? baseTargets.map((row) =>
        mappedTargetIdSet.has(row.CatalogId)
          ? {
            ...row,
            // mark as "in use" locally, but keep any server fields already present
            MappedCatalogId: row.CatalogId,
            MappedCatalogReference: row.CatalogReference,
            MappedArtifactData: row.ArtifactData,
          }
          : row,
      )
      : baseTargets;

    return {
      targetCatalogs: patchedTargets,
    };
  },
);

export const fetchChildSourceCatalogs = createAsyncThunk(
  "crossReference/fetchChildSourceCatalogs",
  async (
    { parentType, childType, setMappedParentCatalogs, searchFilter },
    { getState, dispatch },
  ) => {
    const state = getState();
    const mapOnFlyInfo =
      state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo;
    const operationId =
      state.sessionInfo.workflowManagerSession.selectedWorkflow;
    let response = "";

    if (state.tempInfo.crossReference.isAddCrossRefOpen) {
      response = await axios.get("/crossreference/mapped-catalogs", {
        params: {
          crossReferenceType: mapOnFlyInfo.CrossReferenceTypes[parentType],
          connectionPairId: mapOnFlyInfo.ConnectionPairId,
          sourceConnectionId: mapOnFlyInfo.SourceConnectionId,
          targetConnectionId: mapOnFlyInfo.TargetConnectionId,
          clearCache: true,
        },
      });
    } else {
      response = await axios.get("/crossreference/map-on-fly/mapped-catalogs", {
        params: {
          sourceArtifactId: mapOnFlyInfo.SourceArtifactDictionaryDataId,
          operationId: operationId,
          crossReferenceType: mapOnFlyInfo.CrossReferenceTypes[parentType],
          connectionPairId: mapOnFlyInfo.ConnectionPairId,
          sourceConnectionId: mapOnFlyInfo.SourceConnectionId,
          targetConnectionId: mapOnFlyInfo.TargetConnectionId,
          clearCache: true,
        },
      });
    }

    await setMappedParentCatalogs(response.data.MappedSourceCatalogs);

    dispatch(
      fetchSourceConnectionCatalogs({
        connectionPairId: mapOnFlyInfo.ConnectionPairId,
        crossReferenceType: childType,
        sourceConnectionId: mapOnFlyInfo.SourceConnectionId,
        targetConnectionId: mapOnFlyInfo.TargetConnectionId,
        searchFilter: searchFilter,
      }),
    );
  },
);

export const fetchMappedCatalogs = createAsyncThunk(
  "crossReference/fetchMappedCatalogs",
  async (
    {
      connectionPairId,
      crossReferenceType,
      sourceConnectionId,
      targetConnectionId,
    },
    { getState },
  ) => {
    const state = getState();
    const crossReferenceTypeNum =
      state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
        .CrossReferenceTypes[crossReferenceType];

    let response = "";

    if (!state.tempInfo.crossReference.isAddCrossRefOpen) {
      const operationId =
        state.sessionInfo.workflowManagerSession.selectedWorkflow;
      const sourceArtifactId =
        state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
          .SourceArtifactDictionaryDataId;

      response = await axios.get("/crossreference/map-on-fly/mapped-catalogs", {
        params: {
          sourceArtifactId: sourceArtifactId,
          operationId: operationId,
          crossReferenceType: crossReferenceTypeNum,
          connectionPairId: connectionPairId,
          sourceConnectionId: sourceConnectionId,
          targetConnectionId: targetConnectionId,
          clearCache: true,
        },
      });
    }

    return {
      mappedSourceCatalogs: state.tempInfo.crossReference.isAddCrossRefOpen
        ? []
        : response.data.MappedSourceCatalogs,
    };
  },
);

//map on fly
export const saveNewMappings = createAsyncThunk(
  "crossReference/saveNewMappings",
  async (
    {
      connectionPairId,
      crossReferenceType,
      sourceConnectionId,
      targetConnectionId,
      newMappings,
      usedCatalogs,
    },
    { getState, dispatch, rejectWithValue }
  ) => {
    const state = getState();
    const crossReferenceTypeNum =
      state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
        .CrossReferenceTypes[crossReferenceType];

    const pendingCrossReferences = newMappings.map(mapping => ({
      Catalogue: mapping,
      InsertType: !mapping.InsertType ? CrossReferenceTypes.None : mapping.InsertType,
    }));
    const comparisonInfo = {
      MappedSourceConnectionCatalogs: pendingCrossReferences,
      CatalogsInArtifact: usedCatalogs,
    };
    const params = {
      crossReferenceType: crossReferenceTypeNum,
      sourceConnectionId,
      targetConnectionId,
      connectionPairId,
    };

    try {
      const response = await axios.post(
        "/crossreference/map-on-fly",
        comparisonInfo,
        {
          params: params,
        }
      );

      return response;
    } catch (error) {
      dispatch(
        createAlert({
          status: "Error",
          alertType: "single",
          message: `${error.response.data}`,
        })
      );
      return rejectWithValue(error.response.data);
    }
  }
);

//Add Crossreference Screen
export const saveNewCrossReferenceMappings = createAsyncThunk(
  "crossReference/saveNewCrossReferenceMappings", // changed to prevent reducer conflicts
  async (
    {
      connectionPairId,
      crossReferenceType,
      sourceConnectionId,
      targetConnectionId,
      newMappings,
    },
    { getState, dispatch, rejectWithValue }
  ) => {
    const state = getState();
    const crossReferenceTypeNum =
      state.tempInfo.crossReference.mapOnFlyInfo.crossReferenceInfo
        .CrossReferenceTypes[crossReferenceType];
    const pendingCrossReferences = newMappings.map(mapping => ({
      Catalogue: mapping,
      InsertType: mapping.InsertType,
    }));
    const params = {
      crossReferenceType: crossReferenceTypeNum,
      sourceConnectionId,
      targetConnectionId,
      connectionPairId,
    };


    try {
      const response = await axios.post(
        "/crossreference/cross-reference-mapping",
        {
          PendingCrossReferences: pendingCrossReferences
        },
        {
          params: params,
        }
      );
      return response;
    } catch (error) {
      dispatch(
        createAlert({
          status: "Error",
          alertType: "single",
          message: `${error.response.data}`,
        })
      );
      return rejectWithValue(error.response.data);
    }
  }
);

export const selectReferenceType = (state) =>
  state.tempInfo.crossReference.selectedReferenceType;
export const selectXRefType = (state) =>
  state.tempInfo.crossReference.selectedXref;
export const selectReferenceTypes = (state) =>
  state.tempInfo.crossReference.referenceTypes;
export const selectRows = (state) => state.tempInfo.crossReference.rows;
export const selectConnectionPair = (state) =>
  state.tempInfo.crossReference.connectionPair;
export const selectSelectedRows = (state) =>
  state.tempInfo.crossReference.selectedRows;
export const selectReferenceSchema = (state) =>
  state.tempInfo.crossReference.referenceSchema;
export const selectConnectionPairsList = (state) =>
  state.tempInfo.crossReference.connectionPairsList;
export const selectConnectionCatalogs = (state) =>
  state.tempInfo.crossReference.catalogs;
export const selectMappedSourceCatalogs = (state) =>
  state.tempInfo.crossReference.catalogs.mappedSourceCatalogs;
export const selectMapOnFlyInfo = (state) =>
  state.tempInfo.crossReference.mapOnFlyInfo;
export const selectMapOnFlyInfoLoading = (state) =>
  state.tempInfo.crossReference.mapOnFlyInfo.loading;
export const selectIsMapOnFlyOpen = (state) =>
  state.tempInfo.crossReference.isMapOnFlyOpen;
export const selectCatalogFilter = (state) =>
  state.tempInfo.crossReference.catalogFilter;
export const selectIsAddCrossRefOpen = (state) =>
  state.tempInfo.crossReference.isAddCrossRefOpen;
export const selectToggle = (state) => state.tempInfo.crossReference.toggle;
export const selectMissingCrossRefCounts = (state) =>
  state.tempInfo.crossReference.missingCrossReferenceCounts;
export const selectSourceGridLoaded = (state) =>
  state.tempInfo.crossReference.sourceGridLoaded;
export const selectTargetGridLoaded = (state) =>
  state.tempInfo.crossReference.targetGridLoaded;
export const selectMappedGridLoaded = (state) =>
  state.tempInfo.crossReference.mappedGridLoaded;

export const {
  setReferenceType,
  setReferenceTypeEnum,
  setRowsData,
  setConnectionPair,
  setSelectedRow,
  setReferenceSchema,
  setConnectionPairsList,
  addPendingMappedSourceCatalogs,
  removeMappedSourceCatalog,
  setMapOnFlyInfo,
  clearMapOnFlyInfo,
  setIsMapOnFlyOpen,
  setCatalogFilter,
  setIsAddCrossRefOpen,
  resetCatalogFilter,
  setToggle,
  setMissingCrossRefCounts,
  setSelectedXrefType,
  setMappedGridFlag,
  clearPendingLocalChanges,
} = crossReferenceSlice.actions;
export default crossReferenceSlice.reducer;

export const DefaultMappingTypes = {
  None: -1,
  Default: 0,
  Implicit: 1,
  Invalid: 2,
};
